import React__default, { Component } from 'react';
import { __extends, __assign } from '../../_virtual/_tslib.js';
import withChat from '../Provider/withChat.js';
import { throttle } from 'lodash';
import ConversationQuery from '../ConversationQuery/index.js';
import Composer$1 from '../../components/Composer/index.js';
import promiseSerial from './promiseSerial.js';

var ComposerContainer =
/** @class */
function (_super) {
  __extends(ComposerContainer, _super);

  function ComposerContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.messageQueue = [];
    _this.state = {
      text: '',
      attachments: [],
      collapsed: false
    };
    _this.sendMessage = _this.sendMessage.bind(_this);
    _this.sendMessages = _this.sendMessages.bind(_this);
    _this.handleAttach = _this.handleAttach.bind(_this);
    _this.handleDetach = _this.handleDetach.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleExpand = _this.handleExpand.bind(_this);
    _this.setComposerRef = _this.setComposerRef.bind(_this);
    _this.handleFocusRequested = _this.handleFocusRequested.bind(_this);
    _this.handleAppendText = _this.handleAppendText.bind(_this);
    _this.handleConversationLoaded = _this.handleConversationLoaded.bind(_this);
    _this.startTyping = _this.startTyping.bind(_this);
    _this.throttledStartTyping = throttle(_this.startTyping, 1000);
    return _this;
  }

  ComposerContainer.prototype.componentDidMount = function () {
    if (this.props.chatClient && this.props.conversationId) {
      this.restoreDraft(this.props.conversationId);
      this.forceUpdate(); // TODO: Move conversation to state?
    }
  };

  ComposerContainer.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.chatClient && (this.props.conversationId !== prevProps.conversationId || this.props.authenticatedUserId !== prevProps.authenticatedUserId)) {
      // Store the draft associated with this conversation
      if (prevProps.conversationId) {
        this.saveDraft(prevProps.conversationId);
      } // Empty the composer


      this.setState({
        text: ''
      }); // Restore draft associated with the incoming conversation

      if (this.props.conversationId) {
        this.restoreDraft(this.props.conversationId);
      }
    }
  };

  ComposerContainer.prototype.componentWillUnmount = function () {
    if (this.props.conversationId) {
      this.saveDraft(this.props.conversationId);
    }
  };

  ComposerContainer.prototype.saveDraft = function (conversationId) {
    if (window.sessionStorage) {
      var key = "draft-" + conversationId;

      if (this.state.text !== '' || window.sessionStorage.getItem(key) !== '') {
        window.sessionStorage.setItem(key, this.state.text);
      }
    }
  };

  ComposerContainer.prototype.restoreDraft = function (conversationId) {
    if (window.sessionStorage) {
      var key = "draft-" + conversationId;
      var draft = window.sessionStorage.getItem(key);

      if (draft) {
        this.setState({
          text: draft
        });
      }
    }
  };

  ComposerContainer.prototype.handleAttach = function (attachment) {
    this.setState(function (prevState) {
      var attachments = prevState.attachments;
      attachments.push(attachment);
      return __assign(__assign({}, prevState), {
        attachments: attachments
      });
    });
  };

  ComposerContainer.prototype.handleAppendText = function (text) {
    this.setState(function (prevState) {
      var newText = prevState.text ? prevState.text + ' ' + text : text;
      return __assign(__assign({}, prevState), {
        text: newText
      });
    });
  };

  ComposerContainer.prototype.handleDetach = function (index) {
    this.setState(function (prevState) {
      var attachments = prevState.attachments.filter(function (_a, i) {
        return i !== index;
      });
      return __assign(__assign({}, prevState), {
        attachments: attachments
      });
    });
  };

  ComposerContainer.prototype.handleChange = function (event, conversation) {
    this.setState({
      text: event.target.value,
      collapsed: event.target.value.length > 0
    });

    if (conversation) {
      this.throttledStartTyping(conversation);
    }
  };

  ComposerContainer.prototype.startTyping = function (conversation) {
    conversation.startTyping();
  };
  /**
   * Send a ComposerMessage.
   *
   * One ComposerMessage may result in multiple FirebaseMessages, if it has attachments.
   */


  ComposerContainer.prototype.sendMessage = function (message, conversation) {
    var _this = this;

    var firebaseMessages = [];
    var promisedMessageAttachments = message.attachments.map(function (attachment) {
      return attachment.toMessage(attachment.data, conversation);
    }); // Label each message with some metadata
    // TODO: This fn can be purely functional, and accept `metadata` as an argument

    var metadata = this.props.source ? {
      source: this.props.source
    } : {}; // Convert each attachment into a FirebaseMessage

    return Promise.all(promisedMessageAttachments).then(function (messageAttachments) {
      firebaseMessages.push.apply(firebaseMessages, messageAttachments); // If the message has a text portion, convert it to a FirebaseMessage. It will be sent last.

      if (message.text && message.text.length) {
        var textMessage = conversation.createDraftMessage();
        textMessage.addDraftPart('TEXT', {
          text: message.text
        });
        firebaseMessages.push(textMessage);
      } // Add metadata to each message


      firebaseMessages.forEach(function (message) {
        return message.metadata = metadata;
      }); // Send

      firebaseMessages.forEach(function (message) {
        return conversation.sendMessage(message);
      }); // Fire send message callback if passed in

      if (_this.props.onSendMessage) {
        _this.props.onSendMessage();
      }
    });
  };
  /**
   * Send all the queued ComposerMessages.
   */


  ComposerContainer.prototype.sendMessages = function (conversation) {
    var _this = this;

    if (!this.messageQueue) {
      return;
    } // Send each queued message sequentially


    promiseSerial(this.messageQueue.map(function (message) {
      return function () {
        return _this.sendMessage(message, conversation);
      };
    })); // Empty the queue

    this.messageQueue = [];
  };
  /**
   * Queue messages for sending
   */


  ComposerContainer.prototype.handleSubmit = function (event, conversation) {
    event.preventDefault(); // Stop the typing indicator

    this.throttledStartTyping.cancel();

    if (conversation) {
      conversation.stopTyping();
    } // Convert the current state to a ComposerMessage


    var message = {
      text: this.state.text,
      attachments: this.state.attachments
    }; // Add the message to the queue

    this.messageQueue.push(message); // If we already have a conversation, send immediately.

    if (conversation) {
      this.sendMessages(conversation);
    } else if (this.props.onConversationStarted) {
      this.props.onConversationStarted();
    } // Probably an invariant: You should pass a conversation or a callback to initate one.
    // Reset the composer state


    this.setState({
      text: '',
      attachments: []
    });
  };
  /**
   * Send all queued messages once we have a handle on a conversation to send them to.
   */


  ComposerContainer.prototype.handleConversationLoaded = function (result) {
    if (result.conversation) {
      this.sendMessages(result.conversation);
    }
  };

  ComposerContainer.prototype.handleExpand = function () {
    this.setState({
      collapsed: false
    });
  };
  /**
   * Focus compose bar text area
   */


  ComposerContainer.prototype.handleFocusRequested = function () {
    this.composerRef && this.composerRef.focus();
  };

  ComposerContainer.prototype.setComposerRef = function (textarea) {
    this.composerRef = textarea;
  };

  ComposerContainer.prototype.render = function () {
    var _this = this;

    return React__default.createElement(ConversationQuery, {
      conversationId: this.props.conversationId,
      recipientIds: this.props.guestChatEnabled ? this.props.recipientIds : undefined,
      onCompleted: this.handleConversationLoaded
    }, function (_b) {
      var conversation = _b.conversation,
          loading = _b.loading;
      return React__default.createElement(React__default.Fragment, null, _this.props.suggestedActions && React__default.createElement(_this.props.suggestedActions, {
        onAppendText: _this.handleAppendText,
        onFocusRequested: _this.handleFocusRequested
      }), React__default.createElement(Composer$1, {
        setComposerRef: _this.setComposerRef,
        conversationId: conversation ? conversation.conversationId : undefined,
        loading: loading,
        text: _this.state.text,
        attachments: _this.state.attachments,
        controls: _this.props.controls,
        onAttach: _this.handleAttach,
        onAppendText: _this.handleAppendText,
        onDetach: _this.handleDetach,
        onChange: function onChange(e) {
          return _this.handleChange(e, conversation);
        },
        onFocus: function onFocus(e) {
          _this.setState({
            collapsed: true
          });

          _this.props.onFocus && _this.props.onFocus(e);
        },
        onSubmit: function onSubmit(e) {
          return _this.handleSubmit(e, conversation);
        },
        onExpand: _this.handleExpand,
        collapsed: _this.state.collapsed
      }));
    });
  };

  return ComposerContainer;
}(Component);

var Composer = withChat(ComposerContainer);

export default Composer;
//# sourceMappingURL=index.js.map
